"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconContainer = exports.Checkbox = exports.RadioInput = exports.LabelSpan = exports.RadioLabel = exports.PillsWrapper = exports.Title = void 0;
const styled_components_1 = __importStar(require("styled-components"));
const colors_1 = require("../../../theme/colors");
const layout_1 = require("../../../theme/layout");
exports.Title = styled_components_1.default.div `
  font-family: SwegonBrown;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 17px;
  margin: 8px 0px;
  color: ${colors_1.GREY3};
`;
exports.PillsWrapper = styled_components_1.default.div `
  ${({ $inlineTranslation }) => $inlineTranslation &&
    (0, styled_components_1.css) `
      display: flex;
    `}
`;
exports.RadioLabel = styled_components_1.default.label `
  border: 1px solid ${colors_1.GREY2};
  border-radius: 2px;
  margin-right: 8px;
  padding: 7.5px 12px 8.5px 12px;

  ${({ $inlineTranslation }) => $inlineTranslation &&
    (0, styled_components_1.css) `
      display: flex;
      align-items: end;
    `};
  &:hover {
    cursor: pointer;
  }
`;
exports.LabelSpan = styled_components_1.default.span `
  font-family: SwegonBrown;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0.2px;
  color: ${({ $disabled }) => ($disabled ? colors_1.GREY2 : colors_1.BLACK)};
  margin-left: 8px;
  ${({ $inlineTranslation }) => $inlineTranslation &&
    (0, styled_components_1.css) `
      display: flex;
      label {
        font-weight: bold;
        font-size: 12px;
        line-height: 16px;
        letter-spacing: 0.2px;
      }
    `}
`;
exports.RadioInput = styled_components_1.default.input `
  position: absolute;
  visibility: hidden;
  display: none;
  box-sizing: border-box;
  border-radius: ${layout_1.CORNER_RADIUS_SMALL};
  &:checked + ${exports.RadioLabel} {
    background: ${colors_1.PALE_GREEN};
    border: 2px solid ${colors_1.DARK_GREEN};
  }
  &:disabled + ${exports.RadioLabel} {
    background-color: ${colors_1.LIGHT_GREY};
    border: 2px solid ${colors_1.GREY1};
    color: ${colors_1.GREY2};
  }
`;
exports.Checkbox = styled_components_1.default.input `
  position: absolute;
  visibility: hidden;
  display: none;
  &:checked + ${exports.RadioLabel} {
    background: ${colors_1.PALE_GREEN};
    border: 2px solid ${colors_1.DARK_GREEN};
    box-sizing: border-box;
    border-radius: ${layout_1.CORNER_RADIUS_SMALL};
  }
`;
exports.IconContainer = styled_components_1.default.span `
  position: relative;
  top: 4px;
`;
//# sourceMappingURL=PillsMultipleSelect.styles.js.map